module.exports = __webpack_public_path__ + "static/media/logo_total_gray.e62a1ad7.svg";